export default __webpack_public_path__ + "static/media/ForbiddenError.0545fd70.jpeg";